import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';

type RecipientsTableHeaderProps = {
  isResumeTable?: boolean;
};

const RecipientsTableHeader: FC<RecipientsTableHeaderProps> = ({
  isResumeTable,
}) => {
  const { t } = useTranslate();

  const columns = [
    { key: 'email', content: t('Email') },

    { key: 'name', content: t('Recipient'), hideOnMobile: true },

    !isResumeTable
      ? { key: 'deliveredIp', content: t('IPDelivered'), hideOnMobile: true }
      : null,

    !isResumeTable
      ? { key: 'deliveredDate', content: `${t('Delivered')} (UTC)` }
      : null,

    { key: 'status', content: t('Status') },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default RecipientsTableHeader;
